import StatusFormContainer from './StatusFormContainer';

export default StatusFormContainer;
